export default [{  //工单列表
		path: 'aftersale/order',
		name: 'm_aftersale_order',
		meta: {
			templateManage: {
				workType: 2,
				print: 'b_aftersale_order_printtemplate',
				export: 'b_aftersale_order_exporttemplate'
			},
			appView: {
				viewId: '10002',
				auth: 'b_aftersale_order_viewmanage'
			}
		},
		component: () => import('@/pages/aftersale/aftersale_order_list.vue')
	},
	{  //上门服务记录单列表
		path: 'aftersale/visit_service',
		name: 'm_aftersale_visit_service',
		component: () => import('@/pages/aftersale/aftersale_visit_service_list.vue')
	},
	{  //售后申请单列表
		path: 'aftersale/apply',
		name: 'm_aftersale_apply',
		meta: {
			appView: {
				viewId: '10001',
				auth: 'b_aftersale_apply_viewmanage'
			}
		},
		component: () => import('@/pages/aftersale/aftersale_apply_list.vue')
	},{  //外协招工列表
		path: 'out/sourcing/recruit',
		name: 'm_out_sourcing_recruit',
		meta: {
			appView: {
				viewId: '10009',
				auth: 'b_out_sourcing_recruit_viewmanage'
			}
		},
		component: () => import('@/pages/aftersale/outsource_recruit_list.vue')
	},{  //手动派单
		path: 'aftersale/order/schedule',
		name: 'm_aftersale_order_schedule',
		component: () => import('@/pages/aftersale/aftersale_order_schedule.vue')
	},{  //手动派单日志
		path: 'dispatch/log',
		name: 'm_dispatch_logs',
		component: () => import('@/pages/aftersale/dispatch_logs.vue')
	},
	{  //工单投诉
		path: 'aftersale/order/complaint',
		name: 'm_aftersale_order_complaint',
		component: () => import('@/pages/aftersale/aftersale_order_complaint_list.vue')
	},
];